import { render } from "./PhoneNumberDetails.vue?vue&type=template&id=273991da&ts=true"
import script from "./PhoneNumberDetails.vue?vue&type=script&lang=ts"
export * from "./PhoneNumberDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__